shadow$provide[244] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Axis:{enumerable:true, get:function() {
  return Axis;
}}});
var UAxis = require("../../../util/axis.js");
var UJS = require("../../../util/js.js");
var require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js = require("../../primitive.js");
class Axis extends require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive {
  static initClass() {
    this.traits = ["node", "object", "visible", "style", "line", "axis", "span", "interval", "arrow", "position", "origin", "shade",];
    this.defaults = {end:true, zBias:-1,};
  }
  constructor(node, context, helpers) {
    super(node, context, helpers);
    this.axisPosition = this.axisStep = this.resolution = this.line = this.arrows = null;
  }
  make() {
    const positionUniforms = {axisPosition:this._attributes.make(this._types.vec4()), axisStep:this._attributes.make(this._types.vec4()),};
    this.axisPosition = positionUniforms.axisPosition.value;
    this.axisStep = positionUniforms.axisStep.value;
    let position = this._shaders.shader();
    position.pipe("axis.position", positionUniforms);
    position = this._helpers.position.pipeline(position);
    const styleUniforms = this._helpers.style.uniforms();
    const lineUniforms = this._helpers.line.uniforms();
    const arrowUniforms = this._helpers.arrow.uniforms();
    const unitUniforms = this._inherit("unit").getUnitUniforms();
    const {detail} = this.props;
    const samples = detail + 1;
    this.resolution = 1 / detail;
    const {start, end} = this.props;
    const {stroke, join} = this.props;
    let mask = this._helpers.object.mask();
    const material = this._helpers.shade.pipeline() || false;
    const {crossed, axis} = this.props;
    if (!crossed && mask != null && axis > 1) {
      const swizzle = ["x000", "y000", "z000", "w000"][axis];
      mask = this._helpers.position.swizzle(mask, swizzle);
    }
    const uniforms = UJS.merge(arrowUniforms, lineUniforms, styleUniforms, unitUniforms);
    this.line = this._renderables.make("line", {uniforms, samples, position, clip:start || end, stroke, join, mask, material,});
    this.arrows = [];
    if (start) {
      this.arrows.push(this._renderables.make("arrow", {uniforms, flip:true, samples, position, mask, material,}));
    }
    if (end) {
      this.arrows.push(this._renderables.make("arrow", {uniforms, samples, position, mask, material,}));
    }
    this._helpers.visible.make();
    this._helpers.object.make(this.arrows.concat([this.line]));
    this._helpers.span.make();
    return this._listen(this, "span.range", this.updateRanges);
  }
  unmake() {
    this._helpers.visible.unmake();
    this._helpers.object.unmake();
    return this._helpers.span.unmake();
  }
  change(changed, touched, init) {
    if (changed["axis.detail"] || changed["line.stroke"] || changed["line.join"] || changed["axis.crossed"] || changed["interval.axis"] && this.props.crossed) {
      return this.rebuild();
    }
    if (touched["interval"] || touched["span"] || touched["view"] || touched["origin"] || init) {
      return this.updateRanges();
    }
  }
  updateRanges() {
    const {axis, origin} = this.props;
    const range = this._helpers.span.get("", axis);
    const min = range.x;
    const max = range.y;
    UAxis.setDimension(this.axisPosition, axis).multiplyScalar(min);
    UAxis.setDimension(this.axisStep, axis).multiplyScalar((max - min) * this.resolution);
    return UAxis.addOrigin(this.axisPosition, axis, origin);
  }
}
Axis.initClass();

};